/**
 * Trims any number of slashes before and after a string and fixes multiple slashes inside the string.
 *
 * ```typescript
 * trimAndFixSlashes('//path/is//not/clean/') // returns 'path/is/not/clean'
 * ```
 */
export function trimAndFixSlashes(path) {
    return path
        .split('/')
        .filter((p) => p)
        .join('/');
}
/**
 * Trims any number of end slashes from a string.
 */
export function trimEndSlashes(path) {
    return path.replace(/\/+$/, '');
}
/**
 * Joins a base url and a number of url paths into a url. Avoids any missing or multiple slashes.
 *
 * ```typescript
 * joinUrl('https://zurich.at/', '/path', '/is/always/', null, '/right/', '/') // returns 'https://zurich.at/path/is/always/right/'
 * ```
 */
export function joinUrl(baseUrl, ...paths) {
    const parts = paths.filter((path) => path);
    return `${trimEndSlashes(baseUrl)}/${parts
        .map((path) => trimAndFixSlashes(path))
        .join('/')}`;
}
/**
 * Checks if the URL is a absolute path (no domain part and starts with /).
 *
 * ```typescript
 * isAbsoluteUrlPath('/a/path') // returns true
 * isAbsoluteUrlPath('https://zurich.at/a/path') // returns false
 * ```
 */
export function isAbsoluteUrlPath(url) {
    if (!url.startsWith('/')) {
        // not an absolute path
        return false;
    }
    if (url.startsWith('//')) {
        // relative protocol, so not an absolute path
        return false;
    }
    return true;
}
